export const SCALE = [
    {
        content: [
            {
                title: "Air Quality Index (AQI) categories and color schemes",
                para: [
                    "The AQI is divided into categories based on US EPA standards: Good, Moderate, Unhealthy for sensitive groups, Unhealthy, Very unhealthy, and Hazardous.",
                    "Here is an overview of the color schemes used and the corresponding risk levels."
                ],
            },
        ]
    },
    {
        content: [
            {
                title: "Pollen count scale",
                para: [
                    "The following table shows the risk level for each type of pollen derived by applying universal guidelines to our data and taking percentile values from the extended season for each type of pollen.",
                    "Here's a breakdown of the color schemes we use for our pollen heatmaps and risk levels."
                ],
            }
        ]
    }
]


export const pollenRiskLevels = [
    {
        status: "Low",
        color: "bg-[#39DEA4]"
    },
    {
        status: "Moderate",
        color: "bg-[#FED766]"
    },
    {
        status: "High",
        color: "bg-[#FF9C40]"
    },
    {
        status: "Very High",
        color: "bg-[#EC4B49]"
    }
];

export const AQIPollutantsLevel = [
    {
        status: "Good",
        color: "bg-[#39DEA4]"
    },
    {
        status: "Fine",
        color: "bg-[#FED766]"
    },
    {
        status: "Moderate",
        color: "bg-[#FF9C40]"
    },
    {
        status: "Poor",
        color: "bg-[#CE4030]"
    },
    {
        status: "Very poor",
        color: "bg-[#4A327F]"
    },
    {
        status: "Hazardous",
        color: "bg-[#5F002B]"
    },
]
export const AQILevels = [
    {
        status: "Good",
        color: "bg-[#39DEA4]"
    },
    {
        status: "Moderate",
        color: "bg-[#FED766]"
    },
    {
        status: "Unhealthy for sensitive groups",
        color: "bg-[#FF9C40]"
    },
    {
        status: "Unhealthy",
        color: "bg-[#CE4030]"
    },
    {
        status: "Very unhealthy",
        color: "bg-[#4A327F]"
    },
    {
        status: "Hazardous",
        color: "bg-[#5F002B]"
    },
]

export const TreeScale = [
    {
        label: "Green",
        level: "Low",
        color: "#39DEA4",
        value: "0 - 95"
    },
    {
        label: "Yellow",
        level: "Moderate",
        color: "#FED766",
        value: "96 - 207"
    },
    {
        label: "Orange",
        level: "High",
        color: "#FF9C40",
        value: "208 - 703"
    },
    {
        label: "Red",
        level: "Very high",
        color: "#CE4030",
        value: "704+"
    }
]
export const WeedScale = [
    {
        label: "Green",
        level: "Low",
        color: "#39DEA4",
        value: "0 - 20"
    },
    {
        label: "Yellow",
        level: "Moderate",
        color: "#FED766",
        value: "21 - 77"
    },
    {
        label: "Orange",
        level: "High",
        color: "#FF9C40",
        value: "78 - 266"
    },
    {
        label: "Red",
        level: "Very high",
        color: "#CE4030",
        value: "267+"
    }
]
export const GrassScale = [
    {
        label: "Green",
        level: "Low",
        color: "#39DEA4",
        value: "0 - 29"
    },
    {
        label: "Yellow",
        level: "Moderate",
        color: "#FED766",
        value: "30 - 60"
    },
    {
        label: "Orange",
        level: "High",
        color: "#FF9C40",
        value: "61 - 341"
    },
    {
        label: "Red",
        level: "Very high",
        color: "#CE4030",
        value: "342+"
    }
]